<template>
  <div
    v-for="(item, i) in listSort"
    :key="i"
    class="sorting-element"
  >
    <UiRadio
      :id="item.id"
      data-test="mobile-sort-radio"
      name="sort-radio"
      :label="item.label"
      :isChecked="isChosenSortValue(item.value)"
      @click="emit('chooseSortingValue', item.value)"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { UiRadio } from '@experience/core-radio-ui';
  import { useSortList } from '../composables';
  import type { ListSortItemValue } from '@/shared/models';

  const props = defineProps<{
    selectedValue: ListSortItemValue;
  }>();

  const emit = defineEmits<{
    (e: 'chooseSortingValue', value: ListSortItemValue): void;
  }>();
  const defaultListSort = useSortList();

  const listSort = computed(() => {
    return defaultListSort.map((item) => {
      return {
        ...item,
        selected: item.value === props.selectedValue,
      };
    });
  });

  const isChosenSortValue = (item: string) => item === props.selectedValue;
</script>
